import { Box, ListItem } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import { Typography } from '../../atoms/Typography';

export const LocationGrid = styled(Grid)`
  padding-top: 10px;
`;

export const ContactTypography = styled(Typography)`
  margin-top: 10px;
`;

export const StyledListItem = styled(ListItem)`
  padding: 0px;
`;

export const ZoneTypography = styled(Typography)`
  margin-top: 10px;
`;

export const MapBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '90%',
  borderRadius: (theme.shape.borderRadius as number) * 2,
  overflow: 'hidden',
  boxShadow: theme.shadows[2],
  cursor: 'pointer',

  height: 250,
  [theme.breakpoints.up('sm')]: {
    height: 300,
  },
  [theme.breakpoints.up('md')]: {
    height: 400,
  },

  '& iframe': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 0,
  },
}));